import { useCallback } from 'react';
import UserPreferences from 'src/entities/userPreferences';
import useReduxDownloadMultipleItems from './useReduxDownloadMultipleItems';
import useReduxDownloadAsset from './useReduxDownloadAsset';
import Asset from '../../models/asset';
import Folder from '../../models/folder';

export type UseDownloadItemsParams = {
	shareRef?: string;
	onDownloadFinish: () => void;
}

type DownloadItemsParams = {
	assets: Asset[];
	folders: Folder[];
	withRoundNumber?: boolean;
	downloadAllRounds?: boolean;
	imageSize?: string | null;
	unpreviewable?: boolean;
}

const useDownloadItems = ( { shareRef, onDownloadFinish }: UseDownloadItemsParams ) => {
	const downloadMultipleItems = useReduxDownloadMultipleItems( { shareRef, onDownloadFinish } );
	const downloadAsset = useReduxDownloadAsset( { shareRef, onDownloadFinish } );

	const downloadItems = useCallback( ( {
		assets, folders, withRoundNumber, downloadAllRounds, imageSize, unpreviewable
	}: DownloadItemsParams ) => {
		const isDownloadingOneAsset = assets.length === 1 && folders.length === 0;

		if ( isDownloadingOneAsset ) {
			downloadAsset( {
				asset: assets[ 0 ],
				withRoundNumber,
				allRounds: downloadAllRounds,
				lowRes: imageSize === UserPreferences.assetDownloadsResolutions.lowRes,
				unpreviewable
			} );
		} else {
			downloadMultipleItems( {
				assets,
				folders,
				withRoundNumber,
				lowRes: imageSize === UserPreferences.assetDownloadsResolutions.lowRes,
				unpreviewable
			} );
		}
	}, [ downloadMultipleItems, downloadAsset ] );

	return downloadItems;
}

export default useDownloadItems;
